var Backbone = require('backbone');
var _ = require('lodash');
var $ = require('jquery');
var template = require('../templates/grid.ejs');
var VoteOptionView = require('./vote-option');
var UserView = require('./user');
var PubSub = require('tscom-pubsub');

'use strict';
module.exports = Backbone.View.extend({
    className: 'view-grid',
    events: {
        'click .login': 'voteLogin'
    },  
    /**
  /**
   *
   */
    initialize: function(options) {
        _.bindAll(this, 'render', 'hasSelected');

        this.cms = options.cms;
        this.connect = options.connect;
        this.auth = options.auth;
        this.collection = options.voteOption;
        this.router = options.router;
        this.dataLength = this.collection.models.length;
        this.cloned_collection = _.clone(this.collection);

        this.listenTo(this.collection, 'change:selected', this.hasSelected);
        this.listenTo(this.collection, 'reset', this.render, this);
        this.listenTo(this.auth, 'change:isAuthorized', this.hasSelected);

        this.listenTo(PubSub, 'relayVoteItemHeight', _.bind(this.setCollectiveHeight, this));
        this.itemHeight = 0;
        Backbone.$(window).on('resize', _.bind(function(){
            this.itemHeight = 0;
        }, this));
    },
    /**
   *
   */
    render: function() {

        this.$el.html(template({
            length: this.collection.models.length,
            copy: this.cms.get('text').views_nominee_grid
        }));

        var user = new UserView({
            cms: this.cms,
            auth: this.auth
        });
        this.$('.user-wrapper').append(user.render().$el);
        this.listenTo(user,'trackEvent', function(evt){ this.trigger('trackEvent',evt); });
        this.listenTo(user,'clearUser', function(evt){ this.trigger('clearUser',evt); });

        var columnOption = this.cms.get('text').views_nominee_grid.column_options.toLowerCase();
        var gridName = 'col-opt-'+columnOption;
        var el = $('<ul/>').addClass(gridName);

        this.voteOptions = this.voteOptions || [];
        this.removeOptions();

        _.each(this.collection.models, _.bind(function(value) {

            var option = new VoteOptionView({
                model: value,
                dataLength: this.dataLength,
                cms: this.cms,
                voteOption: this.collection,
                router: this.router
            });
            this.voteOptions.push(option);
            el.append(option.render().$el.css({
                'opacity': 0,
            }));

            option.renderedToDOM();

        }, this));

        this.$('.voting-grid-options').html(el);

        return this;
    },
    removeOptions: function() {
        if(this.voteOptions && this.voteOptions.length > 0) {
            for(var i = 0; i < this.voteOptions.length; i++) {
                this.voteOptions[i].remove();
            }
        }
        this.voteOptions = [];
    },
    /**
   *
   */
    voteLogin: function(e) {
        e.preventDefault();
        this.router.auth();
    },  
    /**
   *
   */
    hasSelected: function(e) {

        console.log('from has selected', e);

        var selected = this.collection.findWhere({
            selected: true
        });

        if (_.isObject(selected)) {

            console.log('1 click', this.cms.get('text')['views_nominee_grid'].disable_confirmation_modal);

            if (this.cms.get('text')['views_nominee_grid'].disable_confirmation_modal == 'true') {

                if (this.auth.get('isAuthorized')) {
                    // this.controller.trackEvent(e, 'eventClickVote');
                    PubSub.trigger('cast-vote');
                } else {
                    this.router.auth();
                    return;
                }
            } else {
                this.router.voting(selected);
            }
        }
    },
    renderedToDOM: function() {
        this.gridTransition();
    },
    /**
   * [setCollectiveHeight description]
   * @param {[type]} height [description]
   */
    setCollectiveHeight: function (height) {
        if(height > this.itemHeight){
            this.itemHeight = height;
            console.log('setCollectiveHeight', this.itemHeight, height);
            var item = this.$('.contestant');
            item.removeAttr('style');
            item.height(height);
        }
    },
    /**
   *
   */
    gridTransition: function() {
        this.$el.find('li').each(function(i, el) {
            console.log('gridTransition', el);
            $(el).delay(i * 50).animate({
                'opacity': 1
            }, 250);

        });
    },
    /**
   *
   */
    shiftText: function() {
        $('.search-text').toggleClass('shift');
    },

    remove: function() {
        this.removeOptions();
    
        Backbone.View.prototype.remove.call(this);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/grid.js
// module id = 232
// module chunks = 0